import { defineKey as T } from 'ha/i18n';

export const STATE_NAME = 'partnerRedirect';

export const Messages = {
  failedToGenerateClick: T('Can not redirect to partner page'),
};
